import clsx from "clsx";
import { NavLink, useMatch, useResolvedPath } from "react-router-dom";
import { ChevronRightIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { useRef, useState, useContext } from "react";
import { sidebar } from "../../pages/dashboard/layout/AdminLayout";
import { useSingleState } from "../../hooks/useSingleState";
import { LogoutContext } from "../../context/LogoutContext";
import { SidebarItem } from "../../containers/dashboard/Sidebar";
import { USER_ROLES } from "../../utils/constants";
import { useAuth } from "../../zustand/auth.store";
import useOnClickOutside from "../../hooks/useClickOutside";


interface IProfileRole {
    roleType: USER_ROLES;
}
const SideDrawer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const logout: any = useContext(LogoutContext)
    const modalRef = useRef<any>()
    const userRole = useAuth.getState().profile! as IProfileRole;

    const sidebarItem = sidebar(userRole?.roleType ?? USER_ROLES.IBILE_ADMIN)

    const handleToggleDrawer = () => {
        setIsOpen(!isOpen);
    };

    useOnClickOutside(modalRef, () => {
        handleToggleDrawer();
    });

    return (
        <div>
            {/* Button to toggle the drawer */}
            <button onClick={handleToggleDrawer} className="mt-3 md:hidden block">
                {isOpen ? <img className="w-10 h-auto" src="/icons/close-nav.svg" /> :

                    <>
                        <div className="w-10 mb-2 border-b-4 border-gray-500" />
                        <div className="w-10 mb-2 border-b-4 border-gray-500" />
                        <div className="w-10 mb-2 border-b-4 border-gray-500" />
                    </>}

            </button>
            {/* <button
               
                className="fixed top-4 right-4 z-50 p-2 rounded-md bg-gray-800 text-white"
            >
                {isOpen ? 'Close Drawer' : 'Open Drawer'}
            </button> */}

            {/* The drawer content */}
            {isOpen && (
                <div className="modal-background fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-70 z-[90]">
                    <div
                        ref={modalRef}
                        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg transition-transform transform ${isOpen ? 'translate-x-0' : 'translate-x-full'
                            }`}
                    >
                        <div className="p-4">
                            {sidebarItem.map((item) => (
                                <SidebarItem
                                    collapsed={false}
                                    key={item.name}
                                    item={item}
                                    offset={30}
                                />
                            ))}


                            <div className="absolute w-full bottom-0 h-16 pl-8 gap-3.5 bg-white flex items-center">
                                <div className="w-full flex cursor-pointer items-center gap-3.5">
                                    <img
                                        src={`/icons/sidebar/logout.svg`}
                                        className={clsx("h-6 w-6")}
                                        alt="log_out"
                                    />

                                    <span
                                        onClick={() => logout?.toggleLogout()}
                                        className={`whitespace-nowrap pc-text-danger`}
                                    >
                                        Log Out
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {/* Overlay to close the drawer when clicked outside */}
            {/* {isOpen && (
                <div
                    className="fixed inset-0 bg-black opacity-50"
                    onClick={handleToggleDrawer}
                ></div>
            )} */}
        </div>
    );
};

export default SideDrawer;
